import { getOptimisedImageUrl } from "shared/helpers/utils";
import { IWidgetItems } from "shared/components/AdPlatformWidgets/components/types";

import get from "lodash/get";

export const getImageData = (
    widgetItem: IWidgetItems,
    containerWidth: number,
    numOfColumns: number
) => {
    const originalSource = get(widgetItem, "children.0.source.Web", "");
    const width = containerWidth / numOfColumns - 10;

    return {
        source: getOptimisedImageUrl(originalSource, {
            width,
            e: "sharpen",
        }),
        aspect_ratio: get(widgetItem, "children.0.source.Web_aspect_ratio", 1),
        originalSource: getOptimisedImageUrl(originalSource, {
            width: width * 2,
            e: "sharpen",
        }),
    };
};
